import React from "react";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { Link } from "react-router-dom";

export default function ListVRF({
  vrfs = [],
  editData,
  deleteData,
  loading,
  titles = [],
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) => checkAccessFn(dashboardData, module, name);

  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } = useSearchPagination(vrfs ? vrfs : []);
  
  return (
    <div className="pt-2 uppercase">
      <div className="flex md:flex-row flex-col  justify-between items-end">
        <Search
          searchKey={[
            "vrf_no",
            "sadad_number",
            "company.name",
            "project_vendor.vendor.name",
            "job_position.name",
            "nationality.name",
            "visa_profession.name",
          ]}
        />
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      </div>
      <div
        className={`grid justify-items-center grid-cols-table-finance-vrf auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {loading && <LoadingWithLable className="col-span-12" />}
        {/* <NoDataFound /> */}
        {!loading && currentList?.length <= 0 && (
          <p className="col-span-8">No Data found</p>
        )}
        {currentList?.map((vrf, index) => (
          <React.Fragment key={vrf?.id}>
            <PaginationIndex index={index} />
            <p>{vrf.vrf_no}</p>
            <p>{vrf.sadad_number}</p>
            <p>{vrf?.company?.name}</p>
            <p>{vrf?.project_vendor?.vendor?.name}</p>
            <p
              className={`${
                vrf?.finance_status === "Completed" ? "text-green-500" : ""
              }`}
            >
              {vrf?.finance_status}
            </p>
            <p>{vrf?.gr_requested_visa_quantity}</p>
            <p>{vrf?.job_position?.name}</p>
            <p>{vrf?.nationality?.name}</p>
            <p>{vrf?.visa_profession?.name}</p>
            <p>{vrf?.available_quantity}</p>
            <div className="flex items-center gap-2">
              {vrf?.finance_requested === "YES" &&
              vrf.finance_status === "Pending" ? (
                <Link
                  to={"confirm-payment"}
                  state={{ vrfId: vrf?.id, vrfNo: vrf?.vrf_no }}
                >
                  <button
                    className={`p-1 text-sm rounded-md ring-1 uppercase ring-red bg-red font-semibold hover:scale-105 text-white`}
                  >
                    Confirm Payment
                  </button>
                </Link>
              ) : (
                <button className={`p-1 px-2 rounded-md ring-1 `}>--</button>
              )}
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-12 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}
